import { Component, Input } from '@angular/core';
import { ItemStructure } from 'src/app/models/domain';

@Component({
  selector: 'em-teamcenter-tab-header',
  styleUrls: ['./teamcenter-tab-header.component.less'],
  templateUrl: './teamcenter-tab-header.component.html',
  standalone: false,
})
export class TeamcenterTabHeaderComponent {
  @Input() public loading = false;
  @Input() public content?: ItemStructure;
}
